import { combineReducers } from "redux";
import { configureStore as configureReduxStore } from "@reduxjs/toolkit";
import { reducer as loginReducer } from "./login/reducer";
import { reducer as trainerReducer } from "./trainer/reducer";
import { reducer as statisticsReducer } from "./statistics/reducer";
import { TLoginActions } from "./login/actions";
import { TTrainerActions, UPDATE_STRING } from "./trainer/actions";
import { TStatisticsActions } from "./statistics/actions";
import { TWSActions } from "./middleware/actions";
import { ThunkAction } from "redux-thunk";
import { socketMiddleware } from "./middleware/websocket-middleware";
import { WS_CONNECTION_CLOSED, WS_CONNECTION_ERROR, WS_CONNECTION_START, WS_CONNECTION_SUCCESS, WS_SEND_MESSAGE } from "./middleware/actions";

export const rootReducer = combineReducers({
  loginReducer: loginReducer,
  trainerReducer: trainerReducer,
  statisticsReducer: statisticsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export type TApplicationActions =
  | TLoginActions
  | TTrainerActions
  | TStatisticsActions
  | TWSActions;

export type AppThunk<TReturn = void> = ThunkAction<
  TReturn,
  RootState,
  unknown,
  TApplicationActions
>;

const wsActions = {
  wsInit: WS_CONNECTION_START,
  wsSendMessage: WS_SEND_MESSAGE,
  onOpen: WS_CONNECTION_SUCCESS,
  onClose: WS_CONNECTION_CLOSED,
  onError: WS_CONNECTION_ERROR,
  onMessage: UPDATE_STRING,
} as const;

export const store = configureReduxStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(socketMiddleware(wsActions)),
});

export const configureStore = () => {
  return store;
};
